import styled from 'styled-components';

const Image = styled.img`
  position: absolute;
  width: 100%;
`;

export default Image;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/ImageBlock/Image.jsx